<template>
  <div class="stat-card">
    <div class="header">
      <span class="title">{{ $lang('订单占比') }}</span>
      <div class="filters">
        <el-radio-group v-model="dateType" size="mini" @change="getData">
          <el-radio-button label="1">{{ $lang('近7日') }}</el-radio-button>
          <el-radio-button label="2">{{ $lang('近1月') }}</el-radio-button>
          <el-radio-button label="3">{{ $lang('近3月') }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="content" v-loading="loading">
      <div class="chart" ref="chart"></div>
      <div class="legend-list">
        <div class="legend-item" v-for="(item, index) in dataList" :key="index">
          <span class="legend-dot" :style="{ backgroundColor: item.color }"></span>
          <span class="name">{{ item.name }}</span>
          <span class="percent">{{ item.percent }}%</span>
          <span class="value">
            <count-to :start-val="0" :end-val="item.value" :duration="2000" separator="," />
            {{ $lang('票') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { reqOrderRate } from '@/api/module/dashboard'
import CountTo from 'vue-count-to'

export default {
  name: 'OrderRatio',
  components: {
    CountTo,
  },
  data() {
    return {
      loading: false,
      chart: null,
      dateType: '1',
      dataList: [
        { name: this.$lang('未取件'), value: 0, percent: 0, color: '#ff4757', valueKey: 'num2', percentKey: 'numRate2' },
        { name: this.$lang('已取件'), value: 0, percent: 0, color: '#ffa502', valueKey: 'num3', percentKey: 'numRate3' },
        { name: this.$lang('运输中'), value: 0, percent: 0, color: '#1e90ff', valueKey: 'num4', percentKey: 'numRate4' },
        { name: this.$lang('派送中'), value: 0, percent: 0, color: '#5352ed', valueKey: 'num5', percentKey: 'numRate5' },
        { name: this.$lang('已签收'), value: 0, percent: 0, color: '#3742fa', valueKey: 'num6', percentKey: 'numRate6' },
        { name: this.$lang('拒签'), value: 0, percent: 0, color: '#2ed573', valueKey: 'num7', percentKey: 'numRate7' },
      ],
    }
  },
  mounted() {
    this.getData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    async getData() {
      const params = {
        dateType: this.dateType,
      }
      try {
        this.loading = true
        const res = await reqOrderRate(params)
        if (res.code === 1) {
          this.dataList.forEach((item) => {
            item.value = res.data[item.valueKey] || 0
            item.percent = res.data[item.percentKey] || 0
          })
          this.initChart()
        }
      } finally {
        this.loading = false
      }
    },
    handleResize() {
      if (this.chart) this.chart.resize()
    },
    initChart() {
      const dom = this.$refs.chart
      this.chart = echarts.getInstanceByDom(dom) || echarts.init(dom)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `
              <div style="max-width: 300px;">${params.name}:</div>
              <div style="font-weight: bold;">${params.value} (${params.percent}%)</div>
            `
          },
          position: 'right',
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: { show: false },
            labelLine: { show: false },
            data: this.dataList?.map((item) => ({
              value: item.value,
              name: item.name,
              itemStyle: { color: item.color },
            })),
          },
        ],
      }
      this.chart.clear()
      this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.stat-card {
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-weight: bold;
      color: #303133;
    }
    .filters {
      .filter-tag {
        font-size: 12px;
        padding: 2px 8px;
        cursor: pointer;
        color: #909399;
        &.active {
          color: #ff4757;
          background: #ffe2e5;
          border-radius: 4px;
        }
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    align-items: center;

    .chart {
      width: 150px;
      height: 150px;
      margin-right: 20px;
    }

    .legend-list {
      flex: 1;
      .legend-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        color: #606266;

        .legend-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .name {
          width: 25%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .percent {
          width: 25%;
          text-align: right;
          margin-right: 10px;
        }
        .value {
          flex: 1;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
